// Multi-language translations (ES/EN)

export const translations = {
  es: {
    // Navigation
    home: 'Inicio',
    search: 'Buscar',
    howItWorks: 'Cómo funciona',
    becomeMobilitier: 'Conviértete en Mobilitier',
    login: 'Iniciar sesión',
    signup: 'Registrarse',
    logout: 'Cerrar sesión',
    myBookings: 'Mis reservas',
    myProfile: 'Mi perfil',
    dashboard: 'Dashboard',
    
    // Hero section
    heroTitle: 'México se va a mover diferente en 2026.',
    heroSubtitle: 'Reserva auto, genera ingresos con tu vehículo y forma parte de la nueva plataforma de movilidad diseñada para el Mundial 2026.',
    searchPlaceholder: 'Busca ciudad, aeropuerto o estadio...',
    searchButton: 'Buscar',
    heroCtaPrimary: 'Reservar un auto',
    heroCtaSecondary: 'Publicar mi auto',
    heroMicrocopy: 'Miles de viajeros llegarán a México en 2026. La demanda ya comenzó.',
    navWorldCup: 'Mundial 2026',
    navStartNow: 'Empezar ahora',

    // World Cup section
    wcEyebrow: 'COPA MUNDIAL FIFA 2026',
    wcTitle: 'Millones de personas llegarán a México. Mobility conecta el movimiento.',
    wcParagraph: 'Mientras las ciudades reciben viajeros de todo el mundo, Mobility permite reservar autos fácilmente o generar ingresos rentando tu vehículo durante los eventos más importantes del 2026.',
    wcStat1: '3 ciudades sede',
    wcStat2: 'Miles de viajeros diarios',
    wcStat3: 'Reservas desde el teléfono',
    wcStat4: 'Disponibilidad limitada',
    wcCtaReserve: 'Reserva antes de que aumente la demanda',
    wcCtaEarn: 'Genera ingresos con el Mundial',

    // Cities
    citiesTitle: 'Las ciudades sede del Mundial',
    citiesSubtitle: 'Reserva en las tres ciudades anfitrionas de México 2026.',

    // App / Trust / Traveler
    appTitle: 'Toda la movilidad en tu bolsillo',
    appSubtitle: 'Reserva, gestiona check-in y comunícate con tu Mobilitier desde la app.',
    trustTitle: 'Confianza desde el primer kilómetro',
    trustSubtitle: 'Verificaciones, soporte humano y reseñas reales en cada renta.',
    trustVerified: 'Verificación de identidad',
    trustSecure: 'Pagos seguros',
    trustSupport: 'Soporte 24/7',
    trustReviews: 'Reseñas reales',
    travelerTitle: 'Libertad para explorar México',
    travelerSubtitle: 'Aeropuertos, ciudades y carreteras. La movilidad simple, sin complicaciones.',

    // Countdown
    cdLabel: 'Copa Mundial FIFA 2026',
    cdSubtitle: 'México vs Sudáfrica · Estadio Azteca · 11 jun · 13:00 CDMX',
    cdDays: 'días',
    cdHours: 'hrs',
    cdMinutes: 'min',
    cdSeconds: 'seg',
    
    // Location selection
    chooseLocation: 'Elige de la localidad de tu preferencia',
    
    // Car types
    sedan: 'Sedán',
    suv: 'SUV',
    pickup: 'Pickup',
    jeep: 'Jeep',
    
    // Steps section
    rentInSteps: 'Renta el auto perfecto en 5 sencillos pasos',
    step1: '1. Busca tu ubicación',
    step2: '2. Selecciona el auto ideal',
    step3: '3. Sube tu licencia',
    step4: '4. Espera aprobación',
    step5: '5. ¡Disfruta tu viaje!',
    
    // Mobilitier section
    becomeMobilitierTitle: 'Tú puedes ser Mobilitier®',
    becomeMobilitierSubtitle: 'Inicia tu propio negocio rentando a particulares',
    joinCommunity: 'Únete a la comunidad de Mobilitiers',
    registerAsMobilitier: 'Registrate como Mobilitier',
    
    // Car listing
    perDay: 'por día',
    automatic: 'Automática',
    manual: 'Manual',
    capacity: 'Capacidad',
    people: 'personas',
    trips: 'viajes',
    instantBooking: 'Reserva instantánea',
    viewDetails: 'Ver detalles',
    bookNow: 'Reservar ahora',
    
    // Filters
    filters: 'Filtros',
    priceRange: 'Rango de precio',
    carType: 'Tipo de auto',
    transmission: 'Transmisión',
    minPrice: 'Precio mínimo',
    maxPrice: 'Precio máximo',
    applyFilters: 'Aplicar filtros',
    clearFilters: 'Limpiar filtros',
    
    // Booking
    selectDates: 'Selecciona fechas',
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
    totalDays: 'Días totales',
    uploadLicense: 'Subir licencia de conducir',
    licenseFront: 'Frente de licencia',
    licenseBack: 'Reverso de licencia',
    requestBooking: 'Solicitar reserva',
    bookingDetails: 'Detalles de reserva',
    rentalPrice: 'Precio de renta',
    deposit: 'Depósito',
    platformFee: 'Tarifa de plataforma',
    deliveryFee: 'Tarifa de entrega',
    totalPrice: 'Precio total',
    
    // Booking status
    pending: 'Pendiente',
    confirmed: 'Confirmada',
    active: 'Activa',
    completed: 'Completada',
    cancelled: 'Cancelada',
    rejected: 'Rechazada',
    
    // Actions
    approve: 'Aprobar',
    reject: 'Rechazar',
    cancel: 'Cancelar',
    modify: 'Modificar',
    message: 'Mensaje',
    review: 'Reseña',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    
    // Check-in/Check-out
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    takePhotos: 'Tomar fotos',
    odometer: 'Odómetro',
    fuelLevel: 'Nivel de gasolina',
    vehicleCondition: 'Condición del vehículo',
    submitCheckIn: 'Completar check-in',
    submitCheckOut: 'Completar check-out',
    
    // Reviews
    writeReview: 'Escribir reseña',
    rating: 'Calificación',
    comment: 'Comentario',
    submitReview: 'Enviar reseña',
    
    // Mobilitier dashboard
    myCars: 'Mis autos',
    addCar: 'Agregar auto',
    pendingApprovals: 'Aprobaciones pendientes',
    earnings: 'Ganancias',
    totalEarnings: 'Ganancias totales',
    monthlyEarnings: 'Ganancias mensuales',
    activeRentals: 'Rentas activas',
    carAvailability: 'Disponibilidad del auto',
    setAvailable: 'Marcar disponible',
    setUnavailable: 'Marcar no disponible',
    pauseListing: 'Pausar publicación',
    
    // Car form
    carDetails: 'Detalles del auto',
    brand: 'Marca',
    model: 'Modelo',
    year: 'Año',
    uploadPhotos: 'Subir fotos (4-8)',
    description: 'Descripción',
    pricePerDay: 'Precio por día',
    location: 'Ubicación',
    features: 'Características',
    mileageLimit: 'Límite de kilometraje (por día)',
    fuelPolicy: 'Política de combustible',
    deliveryAvailable: 'Entrega disponible',
    
    // Messages
    messages: 'Mensajes',
    newMessage: 'Nuevo mensaje',
    sendMessage: 'Enviar mensaje',
    noMessages: 'No hay mensajes',
    
    // Admin
    adminDashboard: 'Dashboard Admin',
    userManagement: 'Gestión de usuarios',
    carManagement: 'Gestión de autos',
    bookingManagement: 'Gestión de reservas',
    disputes: 'Disputas',
    analytics: 'Analíticas',
    platformSettings: 'Configuración de plataforma',
    commissionRate: 'Tasa de comisión',
    
    // Footer
    termsAndConditions: 'Términos y Condiciones',
    privacyPolicy: 'Política de Privacidad de Datos',
    allRightsReserved: 'Todos los derechos reservados',
    
    // Notifications
    bookingRequested: 'Nueva solicitud de reserva',
    bookingApproved: 'Tu reserva ha sido aprobada',
    bookingRejected: 'Tu reserva ha sido rechazada',
    bookingCancelled: 'Reserva cancelada',
    newMessage: 'Nuevo mensaje',
    checkInReminder: 'Recordatorio de check-in',
    checkOutReminder: 'Recordatorio de check-out',
    reviewReminder: 'Deja una reseña de tu experiencia',
  },
  en: {
    // Navigation
    home: 'Home',
    search: 'Search',
    howItWorks: 'How it works',
    becomeMobilitier: 'Become a Mobilitier',
    login: 'Login',
    signup: 'Sign up',
    logout: 'Logout',
    myBookings: 'My bookings',
    myProfile: 'My profile',
    dashboard: 'Dashboard',
    
    // Hero section
    heroTitle: 'Mexico will move differently in 2026.',
    heroSubtitle: 'Book a car, earn with your vehicle, and join the new mobility platform built for the 2026 World Cup.',
    searchPlaceholder: 'Search city, airport or stadium...',
    searchButton: 'Search',
    heroCtaPrimary: 'Book a car',
    heroCtaSecondary: 'List my car',
    heroMicrocopy: 'Thousands of travelers are coming to Mexico in 2026. Demand has already started.',
    navWorldCup: 'World Cup 2026',
    navStartNow: 'Get started',

    wcEyebrow: 'FIFA WORLD CUP 2026',
    wcTitle: 'Millions are coming to Mexico. Mobility connects the movement.',
    wcParagraph: 'As cities welcome travelers from around the world, Mobility lets you book cars easily — or earn renting yours during the biggest events of 2026.',
    wcStat1: '3 host cities',
    wcStat2: 'Thousands of daily travelers',
    wcStat3: 'Book from your phone',
    wcStat4: 'Limited availability',
    wcCtaReserve: 'Book before demand spikes',
    wcCtaEarn: 'Earn with the World Cup',

    citiesTitle: 'The 2026 host cities',
    citiesSubtitle: 'Book in the three Mexican host cities for 2026.',

    appTitle: 'All your mobility in your pocket',
    appSubtitle: 'Book, manage check-in and chat with your Mobilitier in-app.',
    trustTitle: 'Trust from the first kilometer',
    trustSubtitle: 'Verifications, human support and real reviews on every rental.',
    trustVerified: 'ID verification',
    trustSecure: 'Secure payments',
    trustSupport: '24/7 support',
    trustReviews: 'Real reviews',
    travelerTitle: 'Freedom to explore Mexico',
    travelerSubtitle: 'Airports, cities and highways. Simple mobility, zero hassle.',

    // Countdown
    cdLabel: 'FIFA World Cup 2026',
    cdSubtitle: 'Mexico vs South Africa · Estadio Azteca · Jun 11 · 1:00 PM CDMX',
    cdDays: 'days',
    cdHours: 'hrs',
    cdMinutes: 'min',
    cdSeconds: 'sec',
    
    // Location selection
    chooseLocation: 'Choose your preferred location',
    
    // Car types
    sedan: 'Sedan',
    suv: 'SUV',
    pickup: 'Pickup',
    jeep: 'Jeep',
    
    // Steps section
    rentInSteps: 'Rent the perfect car in 5 simple steps',
    step1: '1. Search your location',
    step2: '2. Select the ideal car',
    step3: '3. Upload your license',
    step4: '4. Wait for approval',
    step5: '5. Enjoy your trip!',
    
    // Mobilitier section
    becomeMobilitierTitle: 'You can be a Mobilitier®',
    becomeMobilitierSubtitle: 'Start your own business renting to individuals',
    joinCommunity: 'Join the Mobilitiers community',
    registerAsMobilitier: 'Register as Mobilitier',
    
    // Car listing
    perDay: 'per day',
    automatic: 'Automatic',
    manual: 'Manual',
    capacity: 'Capacity',
    people: 'people',
    trips: 'trips',
    instantBooking: 'Instant booking',
    viewDetails: 'View details',
    bookNow: 'Book now',
    
    // Filters
    filters: 'Filters',
    priceRange: 'Price range',
    carType: 'Car type',
    transmission: 'Transmission',
    minPrice: 'Min price',
    maxPrice: 'Max price',
    applyFilters: 'Apply filters',
    clearFilters: 'Clear filters',
    
    // Booking
    selectDates: 'Select dates',
    startDate: 'Start date',
    endDate: 'End date',
    totalDays: 'Total days',
    uploadLicense: 'Upload driver\'s license',
    licenseFront: 'License front',
    licenseBack: 'License back',
    requestBooking: 'Request booking',
    bookingDetails: 'Booking details',
    rentalPrice: 'Rental price',
    deposit: 'Deposit',
    platformFee: 'Platform fee',
    deliveryFee: 'Delivery fee',
    totalPrice: 'Total price',
    
    // Booking status
    pending: 'Pending',
    confirmed: 'Confirmed',
    active: 'Active',
    completed: 'Completed',
    cancelled: 'Cancelled',
    rejected: 'Rejected',
    
    // Actions
    approve: 'Approve',
    reject: 'Reject',
    cancel: 'Cancel',
    modify: 'Modify',
    message: 'Message',
    review: 'Review',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    
    // Check-in/Check-out
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    takePhotos: 'Take photos',
    odometer: 'Odometer',
    fuelLevel: 'Fuel level',
    vehicleCondition: 'Vehicle condition',
    submitCheckIn: 'Complete check-in',
    submitCheckOut: 'Complete check-out',
    
    // Reviews
    writeReview: 'Write review',
    rating: 'Rating',
    comment: 'Comment',
    submitReview: 'Submit review',
    
    // Mobilitier dashboard
    myCars: 'My cars',
    addCar: 'Add car',
    pendingApprovals: 'Pending approvals',
    earnings: 'Earnings',
    totalEarnings: 'Total earnings',
    monthlyEarnings: 'Monthly earnings',
    activeRentals: 'Active rentals',
    carAvailability: 'Car availability',
    setAvailable: 'Set available',
    setUnavailable: 'Set unavailable',
    pauseListing: 'Pause listing',
    
    // Car form
    carDetails: 'Car details',
    brand: 'Brand',
    model: 'Model',
    year: 'Year',
    uploadPhotos: 'Upload photos (4-8)',
    description: 'Description',
    pricePerDay: 'Price per day',
    location: 'Location',
    features: 'Features',
    mileageLimit: 'Mileage limit (per day)',
    fuelPolicy: 'Fuel policy',
    deliveryAvailable: 'Delivery available',
    
    // Messages
    messages: 'Messages',
    newMessage: 'New message',
    sendMessage: 'Send message',
    noMessages: 'No messages',
    
    // Admin
    adminDashboard: 'Admin Dashboard',
    userManagement: 'User management',
    carManagement: 'Car management',
    bookingManagement: 'Booking management',
    disputes: 'Disputes',
    analytics: 'Analytics',
    platformSettings: 'Platform settings',
    commissionRate: 'Commission rate',
    
    // Footer
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    allRightsReserved: 'All rights reserved',
    
    // Notifications
    bookingRequested: 'New booking request',
    bookingApproved: 'Your booking has been approved',
    bookingRejected: 'Your booking has been rejected',
    bookingCancelled: 'Booking cancelled',
    newMessage: 'New message',
    checkInReminder: 'Check-in reminder',
    checkOutReminder: 'Check-out reminder',
    reviewReminder: 'Leave a review of your experience',
  }
};